import { Component } from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CustomerService} from "../../services/customer.service";

@Component({
  selector: 'app-customer-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss']
})
export class UserDialogComponent {
  public events: any[] = [
    {
      name: 'Bestellbestätigung',
      type: 'order_confirmation',
    }
  ];

  public event = "";

  public customerForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    hubspotToken: new FormControl(''),
    description: new FormControl(''),
    active: new FormControl(true),
  });

  constructor(
    private matDialog: MatDialog,
    private customerService: CustomerService
  ) { }

  onCancel() {
    this.matDialog.closeAll();
  }

  onOk() {
    this.customerService.createCustomer(this.customerForm.value).subscribe((res: any) => {
      this.matDialog.closeAll();
    });
  }
}
